module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Bolton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("SHARON BOLTON is a Mary Higgins Clark Award winner and an ITW Thriller Award, CWA Gold Dagger and Barry Award nominee. Her books included the Lacey Flint novels:"), _c('I', [_vm._v(" Now You See Me, Dead Scared, Lost, ")]), _vm._v("and"), _c('I', [_vm._v(" A Dark and Twisted Tide")]), _vm._v(". She lives near London, England. Sharon Bolton was previously published as S.J. Bolton.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VxuELV/tc-custom/9781250103437.jpg?1731183341452",
      "alt": "This image is the cover for the book Daisy in Chains"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Daisy in Chains\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A “chilling tale of a master manipulator who leaves nothing to chance” from the award-winning author of the Lacey Flint novels ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _vm._v("He’s a serial killer. A murderer of young women, all killed in brutal attacks."), _c('br'), _c('br'), _vm._v("But despite Hamish Wolfe’s conviction, he’s always stuck to his story—he’s innocent and he’s been wrongly imprisoned. And now he wants someone to investigate and, more importantly, to write his story."), _c('br'), _c('br'), _vm._v("Maggie Rose is a notorious defense attorney and writer whose specialty is getting convictions overturned. At first, Maggie is reluctant to even acknowledge Hamish’s requests to meet, ignoring his letters. But this is a very charismatic and persuasive man, good-looking and intelligent."), _c('br'), _c('br'), _vm._v("Eventually even she can’t resist his lure . . . "), _c('br'), _c('br'), _c('b', [_vm._v("“If ever a novel should be read with a friend, Sharon Bolton’s "), _c('i', [_vm._v("Daisy Chains")]), _vm._v(" is it. (You really don’t want to face that mind-blowing ending alone.)” —"), _c('i', [_vm._v("The New York Times Book Review")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0